import { Guid } from './types'
import { ClassResultResponse } from './get-class-result'

type StudentWithScoresLike = {
    userId: Guid
    scores: Map<Guid, number>
    finalScore?: number
    comment: string
    contentItemResultType?: number | undefined
    isScoreAndResultAvailableInAPI: boolean
    isNoShowTechResultsSelected: boolean
    isActivitiesCommentsDisabled: boolean
    recommendLevelChange: boolean
    recommendAdvSession: boolean
    levelChangeRecommendation: string
    advSessionRecommendation: string
}

const toBooleanRecommendation = (value: boolean | null | undefined): boolean => value === true

const toRecommendationComment = (comment: string | null | undefined): string => comment ?? ''

export const restoreRatingsFromClassResult = (
    response: ClassResultResponse,
    students: StudentWithScoresLike[]
): void => {
    const studentsById = new Map<Guid, StudentWithScoresLike>()
    for (const student of students) {
        studentsById.set(student.userId, student)
    }

    for (const result of response.results) {
        const student = studentsById.get(result.studentReferenceId)
        if (!student) {
            continue
        }

        for (const canDoResult of result.canDoResults ?? []) {
            if (canDoResult.score !== null) {
                student.scores.set(canDoResult.id, canDoResult.score)
            }
        }

        student.finalScore = result.score ?? void 0
        student.comment = result.comment ?? ''
        student.contentItemResultType = result.resultType ?? undefined
        student.isScoreAndResultAvailableInAPI = result.score !== null && result.resultType !== null
        student.isNoShowTechResultsSelected = result.resultType !== null && result.resultType > 2
        student.isActivitiesCommentsDisabled = student.isNoShowTechResultsSelected &&
            [...student.scores.values()].length === 0
        student.recommendLevelChange = toBooleanRecommendation(result.isLevelChangeRecommended)
        student.recommendAdvSession = toBooleanRecommendation(result.isAdvisingSessionRecommended)
        student.levelChangeRecommendation = toRecommendationComment(result.levelChangeComment)
        student.advSessionRecommendation = toRecommendationComment(result.advisingSessionComment)
    }
}
